import { template1 } from "ce/pages/Applications/DataModels/templates/template1";
import { template2 } from "ce/pages/Applications/DataModels/templates/template2";
import { template3 } from "ce/pages/Applications/DataModels/templates/template3";
import { template4 } from "ce/pages/Applications/DataModels/templates/template4";
import { template5 } from "ce/pages/Applications/DataModels/templates/template5";
import { template6 } from "ce/pages/Applications/DataModels/templates/template6";

const templateSeeds = [
  template1,
  template2,
  template3,
  template4,
  template5,
  template6,
];

export { templateSeeds };
